import ApiService from "@/core/services/api.service";

export default {
  /**
   *
   * @param context
   * @param payload
   */
  updateStaffGeneralDetails(context, payload) {
    ApiService.setHeader();
    return ApiService.post(
      "school/employee/staff/details/general",
      payload
    ).then((res) => {
      return res;
    });
  },
};
